// @flow
import React from 'react';
import { EditRenderer } from '@components/views/grid-utils/renderers';
import { SPStreamGovernanceConfigurationAddEditModal } from '@streaming-projects/resource-definitions/stream-governance-resource-definitions/SPStreamGovernanceConfigurationAddEditModal';

export const StreamGovernanceResourceEditRenderer = ({ data }) => {
  return (
    <EditRenderer>
      {(isEditModalOpen, setEditModalOpen) => {
        return (
          <SPStreamGovernanceConfigurationAddEditModal
            initialValues={data}
            isEditingMode={true}
            isOpen={isEditModalOpen}
            setOpen={setEditModalOpen}
          />
        );
      }}
    </EditRenderer>
  );
};
